import * as tslib_1 from "tslib";
import getAttachmentPreviewsOperation from 'owa-service/lib/operation/getAttachmentPreviewsOperation';
import getAttachmentPreviewsRequest from 'owa-service/lib/factory/getAttachmentPreviewsRequest';
export default function getAttachmentPreviews(conversationIds, requestOptions, requestData) {
    var requestBody = getAttachmentPreviewsRequest(tslib_1.__assign({}, requestData, { ConversationIds: conversationIds }));
    return getAttachmentPreviewsOperation(requestBody, requestOptions).then(function (response) {
        return response;
    });
}
//# sourceMappingURL=getAttachmentPreviews.js.map